import {useContext, useEffect, useState} from 'react';
import {
  meissaApi,
  MeissaResponse,
  SnapshotItem,
  useMeissaApi,
  deviceApi,
  CctvResponse,
  GasDetectorResponse,
  HookResponse
} from 'modules/maps';
import {PushContext} from "../../../../contexts";

export const usePtwMapData = ({ fetchDevices = false } = {}) => {
  const [meissaAuth, setMeissaAuth] = useState<MeissaResponse | null>(null);
  const [snapshots, setSnapshots] = useState<SnapshotItem[]>([]);
  const [selectedSnapshot, setSelectedSnapshot] = useState<SnapshotItem | null>(null);

  // CCTV
  const [cctvList, setCctvList] = useState<CctvResponse[]>([]);
  const [selectedCctv, setSelectedCctv] = useState<CctvResponse | null>(null);

  // Gas Detector
  const [gasDetectorList, setGasDetectorList] = useState<GasDetectorResponse[]>([]);

  // Hook
  const [hookList, setHookList] = useState<HookResponse[]>([]);

  const { getSnapshotList, setTokens } = useMeissaApi(meissaAuth || undefined);

  // Meissa 인증 + 스냅샷 로드
  useEffect(() => {
    let alive = true;

    const initMeissaAuth = async () => {
      try {
        const tokenData = await meissaApi.token();
        if (!alive) return;

        if (!tokenData?.resultObject) {
          console.warn('Meissa Token Create Failed');
          return;
        }

        const { access, refresh, projectId } = tokenData.resultObject;
        setMeissaAuth({ access, refresh, projectId });
        setTokens(access, refresh);

        const snapshotList = await getSnapshotList(projectId);
        if (!alive) return;

        if (snapshotList?.results && snapshotList.results.length > 0) {
          //console.log(11212, snapshotList.results)
          const filteredSnapshots = snapshotList.results.filter(
              (item) => item.data_process_history === 'DONE' && !!item.orthophoto_thumbnail
          );
          setSnapshots(filteredSnapshots);
          setSelectedSnapshot(filteredSnapshots[0]);
        }
      } catch (error) {
        console.error('Meissa Token Create Failed:', error);
      }
    };

    initMeissaAuth();

    return () => {
      alive = false;
    };
  }, []);

  // CCTV + IOT 장비 목록 로드 (fetchDevices=true 일 때만 호출)
  useEffect(() => {
    if (!fetchDevices) return;

    let alive = true;

    deviceApi
      .getCctvList()
      .then((response) => {
        if (!alive) return;
        setCctvList(response.resultList ?? []);
      })
      .catch((error) => {
        console.error('Failed to fetch CCTV list:', error);
        if (!alive) return;
        setCctvList([]);
      });

    deviceApi
      .getGasDetectorList()
      .then((response) => {
        if (!alive) return;
        setGasDetectorList(response.resultList ?? []);
      })
      .catch((error) => {
        console.error('Failed to fetch Gas Detector list:', error);
        if (!alive) return;
        setGasDetectorList([]);
      });

    deviceApi
      .getHookList()
      .then((response) => {
        if (!alive) return;
        setHookList(response.resultList ?? []);
      })
      .catch((error) => {
        console.error('Failed to fetch Hook list:', error);
        if (!alive) return;
        setHookList([]);
      });

    return () => {
      alive = false;
    };
  }, [fetchDevices]);

  const { wsActiveIotDevice } = useContext(PushContext);
  useEffect(() => {
    var data = wsActiveIotDevice
    var _cctvList = data?.cctvList
    var _gasDetectorList = data?.gasDetectorList
    var _hookList = data?.hookList
    setCctvList(_cctvList ?? []);
    setGasDetectorList(_gasDetectorList ?? []);
    setHookList(_hookList ?? []);
  }, [wsActiveIotDevice]);

  return {
    meissaAuth,
    snapshots,
    selectedSnapshot,
    setSelectedSnapshot,
    cctvList,
    selectedCctv,
    setSelectedCctv,
    gasDetectorList,
    hookList
  };
};
